module.exports = __webpack_public_path__ + "img/n11.d7efae88.png";